export var designApiRelativePath = "/helpcenter/appearance/design";
export var createDesignApi = function (baseUrl, http) {
    var apiUrl = "".concat(baseUrl).concat(designApiRelativePath);
    return {
        getDesign: function () { return http.get("".concat(apiUrl)); },
        updateDesign: function (dto) {
            return http.put("".concat(apiUrl), dto.data);
        }
    };
};
//# sourceMappingURL=index.js.map